import { BehaviorSubject } from "rxjs";

const paginationSubject = new BehaviorSubject(null);

export const paginationService = {
  pagination$: paginationSubject.asObservable(),
  getPagination: () => paginationSubject.value,
  setPagination: (data) => paginationSubject.next(data),
};
